import React from 'react';
import './Cooperation.scss';
import { join } from "@/fetch";
const $ = window.$;
class Cooperation extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [
        { imgPath: require("img/Cooperationbg.png"), imgHDPath: `${require("img/Cooperationbg.png")} 1x,${require("img/Cooperationbg@2x.png")} 2x,${require("img/Cooperationbg@3x.png")} 3x`, attachURL: "/" },
      ],
      bannerImages2: [
        { imgPath: require("img/Cooperationbg2.png"), imgHDPath: `${require("img/Cooperationbg2.png")} 1x,${require("img/Cooperationbg2@2x.png")} 2x,${require("img/Cooperationbg2@3x.png")} 3x`, attachURL: "/" },
      ],
      bannerImages3: [
        { imgPath: require("img/Cooperationbg3.png"), imgHDPath: `${require("img/Cooperationbg3.png")} 1x,${require("img/Cooperationbg3@2x.png")} 2x,${require("img/Cooperationbg3@3x.png")} 3x`, attachURL: "/" },
      ],
      applyFor: [
        { imgPath: require("img/next1.png"), imgHDPath: `${require("img/next1.png")} 1x,${require("img/next1@2x.png")} 2x,${require("img/next1@3x.png")} 3x`, attachURL: "/" },
      ],
      applyFor2: [
        { imgPath: require("img/next2.png"), imgHDPath: `${require("img/next2.png")} 1x,${require("img/next2@2x.png")} 2x,${require("img/next2@3x.png")} 3x`, attachURL: "/" },
      ],
      applyFor3: [
        { imgPath: require("img/next3.png"), imgHDPath: `${require("img/next3.png")} 1x,${require("img/next3@2x.png")} 2x,${require("img/next3@3x.png")} 3x`, attachURL: "/" },
      ],
      applyFor4: [
        { imgPath: require("img/next4.png"), imgHDPath: `${require("img/next4.png")} 1x,${require("img/next4@2x.png")} 2x,${require("img/next4@3x.png")} 3x`, attachURL: "/" },
      ],
      applyFor5: [
        { imgPath: require("img/next5.png"), imgHDPath: `${require("img/next5.png")} 1x,${require("img/next5@2x.png")} 2x,${require("img/next5@3x.png")} 3x`, attachURL: "/" },
      ],
      applyFor6: [
        { imgPath: require("img/next6.png"), imgHDPath: `${require("img/next6.png")} 1x,${require("img/next6@2x.png")} 2x,${require("img/next6@3x.png")} 3x`, attachURL: "/" },
      ],
      telImg: [
        { imgPath: require("img/tel.png"), imgHDPath: `${require("img/tel.png")} 1x,${require("img/tel@2x.png")} 2x,${require("img/tel@3x.png")} 3x`, attachURL: "/" },
      ],
      emailImg: [
        { imgPath: require("img/email.png"), imgHDPath: `${require("img/email.png")} 1x,${require("img/email@2x.png")} 2x,${require("img/email@3x.png")} 3x`, attachURL: "/" },
      ],
      CooperationName: '',//姓名
      CooperationEmail: '',
      Cooperationcompany: '',
      Cooperationtel: '',
      Cooperationleave: '',
      toastName: '信息不完整,请重新填写~',
      CooperationleaveNum: 0,
    }
  }
  componentDidMount() {

  }
  //申请合作
  applyFn() {
    const clickHeight = $('.collaborate-relation').offset().top;
    window.scrollTo(0, clickHeight);
  }
  //姓名
  CooperationNameFn(e) {
    this.setState({
      CooperationName: e.target.value
    })
  }
  //邮箱
  CooperationEmailFn(e) {
    this.setState({
      CooperationEmail: e.target.value
    })
  }
  //公司
  CooperationcompanyFn(e) {
    this.setState({
      Cooperationcompany: e.target.value
    })
  }
  //电话
  CooperationtelFn(e) {
    this.setState({
      Cooperationtel: e.target.value
    })
  }
  //留言
  CooperationleaveFn(e) {
    let getValue = e.target.value;
    let len = getValue.length;
    this.setState({ Cooperationleave: getValue, CooperationleaveNum: len });
  }
  //提交按钮
  collaborateSubmit() {
    // let toast = document.querySelector('.toast');
    // toast.style.display = 'block';
    // toast.classList.add("Aniamtioncover");
    // setTimeout(function(){
    //     toast.style.display = 'none';
    // },2000);
    if (this.state.CooperationName && this.state.CooperationEmail && this.state.Cooperationcompany && this.state.Cooperationtel) {
      if (!(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.state.CooperationEmail))) {
        this.changeTitle('请输入正确的邮箱！')
      } else if (!(/^[1][3-9]\d{9}$/.test(this.state.Cooperationtel))) {
        this.changeTitle('请输入正确的电话！')
      } else {
        let data = {}
        data.name = this.state.CooperationName
        data.email = this.state.CooperationEmail
        data.company = this.state.Cooperationcompany
        data.tel = this.state.Cooperationtel
        data.msg = this.state.Cooperationleave
        join.addOrUpdateCooperationApply(data).then(res => {
          if (res.errorCode === "200") {
            this.changeTitle('提交成功！')
            //this.props.history.go(0);//强制刷新当前路由
            this.setState({
              CooperationName: '',
              CooperationEmail: "",
              Cooperationcompany: '',
              Cooperationtel: "",
              Cooperationleave: ''
            })
          } else {
            this.changeTitle(res.errorMsg)
          }
        }).catch(err => {
          this.changeTitle(err.errorMsg)
          console.log(err);
        })
      }
      // this.props.history.go(0)
    } else {
      this.changeTitle('信息不完整,请重新填写~')
    }
  }
  changeTitle(title) {
    let toast = document.querySelector('.toast');
    toast.style.display = 'block';
    toast.classList.add("Aniamtioncover");
    setTimeout(function () {
      toast.style.display = 'none';
    }, 2000);
    this.setState({
      toastName: title
    })
  }
  render() {
    const { CooperationName, CooperationEmail, Cooperationcompany, Cooperationtel, Cooperationleave, toastName, CooperationleaveNum } = this.state
    return (
      <div className='Cooperation'>
        <main className="Cooperation-body">
          <section className="swiper-container">
            <div className="swiper-wrapper">
              {
                this.state.bannerImages.map((item, index) =>
                  <a className="swiper-slide"
                    key={index}
                    href={item.attachURL}>
                    <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                  </a>
                )
              }
            </div>
            <div className="swiper-pagination"></div>
            <h5>事业合伙人招募</h5>
            <p>秉承"双赢互利，共同发展"的合作理念，诚邀认同青矩技术品</p>
            <p>牌价值的各界翘楚及有志之士，成为青矩技术的销售伙伴，共</p>
            <p>同开发销售渠道。</p>
            <button onClick={this.applyFn.bind(this)}>立即申请</button>
          </section>
          <div className='Cooperation-cost'>
            <p><i></i><span>慧心明智 轻举未来</span></p>
            <p className='cost-txt'>青矩技术是国内最大的工程综合咨询服务机构之一，工程造价咨询的龙头企业。一方面构建起了包括工程投资咨询、工程设计、工程招标代理、工程造价咨询、项目风险管控、工程财务咨询等在内的全过程工程咨询产业链；另一方面不断完善业务布局，延伸服务网络。目前公司分支机构发展全国30多个中心城市，服务国家重点工程和建设项目累计投资额高达上万亿元，专业范围覆盖房屋建筑、能源化工、公共交通、通信工程等多个领域。</p>
          </div>
          <section className="swiper-container">
            <div className="swiper-wrapper">
              {
                this.state.bannerImages2.map((item, index) =>
                  <a className="swiper-slide"
                    key={index}
                    href={item.attachURL}>
                    <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                  </a>
                )
              }
            </div>
            <div className="swiper-pagination"></div>
          </section>
          <div className='Cooperation-cost condition'>
            <p><i></i><span>加盟条件</span></p>
            <ul>
              <li>• 具有合法经营资格，具有一定的履约能力</li>
              <li>• 认同青矩品牌价值以及青矩渠道产品经销商策略</li>
              <li>• 须具有良好的商业信誉，无不良记录，无法律纠纷</li>

            </ul>
          </div>
          <section className="swiper-container">
            <div className="swiper-wrapper">
              {
                this.state.bannerImages3.map((item, index) =>
                  <a className="swiper-slide"
                    key={index}
                    href={item.attachURL}>
                    <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                  </a>
                )
              }
            </div>
            <div className="swiper-pagination"></div>
          </section>
          <div className='Cooperation-cost collaborate'>
            <p><i></i><span>合作伙伴申请流程</span></p>
            <div className='collaborate-child'>
              <p className='collaborate-child-line'></p>
              <div className='collaborate-child-apply'>
                {
                  this.state.applyFor.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>申请</span>
              </div>
              <div className='collaborate-child-estimated'>
                {
                  this.state.applyFor2.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>初步评估</span>
                <p>对申请者资质等信息进行初步审核</p>
              </div>
              <div className='collaborate-child-estimated collaborate-child-inspect'>
                {
                  this.state.applyFor3.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>现场考察</span>
                <p>对通过初步评估的申请人进行现场走访考察</p>
              </div>
              <div className='collaborate-child-estimated collaborate-child-assess'>
                {
                  this.state.applyFor4.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>综合评估</span>
                <p>综合申请人提供的材料和现场考察情况，进行综合评估</p>
              </div>
              <div className='collaborate-child-estimated collaborate-child-develop'>
                {
                  this.state.applyFor5.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>发展审批</span>
                <p>根据综合评估的结果进行审批</p>
              </div>
              <div className='collaborate-child-apply collaborate-child-protocol'>
                {
                  this.state.applyFor6.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>签订协议</span>
              </div>
            </div>
          </div>
          <div className='collaborate-relation'>
            <p><i></i><span>申请成为事业合伙人</span></p>
            <h5>联系我们</h5>
            <div className='collaborate-tel'>
              {
                this.state.telImg.map((item, index) =>
                  <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                )
              }
              <span>招商热线：<a href="tel:400-607-8818">400-607-8818</a></span>
            </div>
            <div className='collaborate-tel collaborate-email'>
              {
                this.state.emailImg.map((item, index) =>
                  <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                )
              }
              <span>电子邮箱：<a href="mailto:greetec@greetec.com">greetec@greetec.com</a></span>
            </div>
          </div>
          <div className='collaborate-message'>
            <h5>提交您的信息</h5>
            <form>
              <span>姓名<i>*</i></span>
              <input type="text" placeholder='请输入您的姓名' value={CooperationName} onChange={this.CooperationNameFn.bind(this)} />
            </form>
            <form>
              <span>
                邮箱<i>*</i></span>
              <input type="text" placeholder='请输入' value={CooperationEmail} onChange={this.CooperationEmailFn.bind(this)} />
            </form>
            <form>
              <span>
                公司<i>*</i></span>
              <input type="text" placeholder='请输入' value={Cooperationcompany} onChange={this.CooperationcompanyFn.bind(this)} />
            </form>
            <form>
              <span>电话<i>*</i></span>
              <input type="text" placeholder='请输入' value={Cooperationtel} onChange={this.CooperationtelFn.bind(this)} />
            </form>
            <form className='texta'>
              <span style={{
                fontWeight: "400"
              }}>留言</span>
              <span>
                <textarea rows="1" style={{ height: "30px", width: "100%", fontSize: '16px' }} disabled={CooperationleaveNum === 1000 ? "disabled" : ''} value={Cooperationleave} onChange={this.CooperationleaveFn.bind(this)}></textarea>
                <span style={{ fontWeight: "400" }}>{CooperationleaveNum === 0 ? 0 : CooperationleaveNum}/1000</span>
              </span>
            </form>
          </div>
          <div className='collaborate-submit'>
            <button onClick={this.collaborateSubmit.bind(this)}>提交</button>
          </div>
        </main>
        <div className='toast'>{toastName}</div>
      </div>
    );
  }
}

export default Cooperation;
